/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Prescription } from '../../models/prescription';

export interface GetPrescriptions$Params {
  id: string;
}

export function getPrescriptions(http: HttpClient, rootUrl: string, params: GetPrescriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Prescription>>> {
  const rb = new RequestBuilder(rootUrl, getPrescriptions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Prescription>>;
    })
  );
}

getPrescriptions.PATH = '/api/visits/{id}/prescriptions';
